import styled, { css } from "styled-components";
import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import { Text } from "@ubnt/ui-components/Text";
import { ScrollWrapper } from "@ubnt/store.core/lib/components/ScrollWrapper";
import { ScrollContainer } from "@ubnt/store.core/lib/components/ScrollWrapper/ScrollWrapper.styles";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Tab = styled.button<{ $isActive: boolean }>`
  background: transparent;
  outline: none;
  display: flex;
  padding: 10px 20px;
  flex-direction: column;
  align-items: center;
  color: ${({ theme }) => theme.colors.neutral09};
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.28px;
  border: none;

  &:hover {
    color: ${({ theme }) => theme.colors.ublue06} !important;
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      border-bottom: 2px solid ${({ theme }) => theme.colors.ublue06};
      color: ${({ theme }) => theme.colors.ublue06} !important;
      text-shadow:
        0.25px 0px 0.1px ${({ theme }) => theme.colors.ublue06},
        -0.25px 0px 0.1px ${({ theme }) => theme.colors.ublue06};
    `}
`;

export const HeadingContainer = styled.div`
  padding: 0px 10px;
  margin: 0 0 48px;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    margin: 48px 0 24px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    margin-bottom: 15px;
  }
`;

export const SubHeading = styled.div`
  color: ${({ theme }) => theme.colors.text2};
  font-size: 18px;
  font-weight: 400;
  line-height: normal;
  margin: 0;

  margin-top: 8px;
`;
export const BrandTrustContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  max-width: 100%;
`;

export const IndustrySelectorWrapper = styled.div`
  width: fit-content;
  display: flex;
  width: fit-content;
  align-items: center;
  position: relative;
  box-shadow: inset 0 -1px 0 0 ${({ theme }) => theme.colors.neutral04};

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    width: 100%;
  }
`;

export const IndustrySelectorContainer = styled.div`
  justify-content: flex-start;
  display: flex;
  align-items: center;
  position: relative;
  gap: 10px;

  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  ::-webkit-scrollbar {
    display: none;
  }

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    gap: 0;
  }
`;

export const LogoContainer = styled.div`
  align-items: center;
  column-gap: 54px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-top: 56px;
  max-width: 1196px;
  row-gap: 46px;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    margin-top: 42px;
    column-gap: 41px;
    row-gap: 18px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    column-gap: 16px;
    row-gap: 8px;
    margin-top: 24px;
  }
`;

export const LogoBox = styled.div<{ $fadeOut: boolean }>`
  flex-grow: 1;
  text-align: center;
  opacity: 1;
  transition: all 0.5s ease-in;

  ${({ $fadeOut }) =>
    $fadeOut &&
    css`
      filter: grayscale(1);
      opacity: 0.3;
    `}
`;

// really just trying to keep the logos close to the design
export const BrandTrustLogo = styled.img`
  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    max-height: 20px;
    max-width: 115px;
    min-width: 16px;
  }
`;

export const TabScrollContainer = styled(ScrollWrapper)`
  display: flex;
  width: 100%;

  @media (${BREAKPOINTS.TABLET_AND_DOWN}) {
    margin: 0;
  }

  ${ScrollContainer} {
    display: flex;
    gap: 0;
    margin-top: 0;
    padding: 0;
    width: 100%;
  }

  .scroll-container-item {
    width: calc(100 / 6% - 12px);
    min-width: fit-content;
  }
`;

export const StyledTitle = styled(Text)`
  font-size: 42px;
  line-height: normal;
  text-wrap: balance;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    font-size: 32px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 24px;
  }
`;

export const StyledDescription = styled(Text)`
  line-height: 26px;
  text-wrap: balance;
  color: ${({ theme }) => theme.colors.neutral08};

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    font-size: 16px;
  }
`;
